"use strict";

const codes = [
  {
    code: "qd",
    label: "every day",
    mobileLabel: "Every day",
    level: 1
  },
  {
    code: "qod",
    label: "every other day",
    mobileLabel: "Every other day",
    level: 1
  },
  {
    code: "bid",
    label: "2 times per day",
    mobileLabel: "Twice a day",
    level: 2
  },
  {
    code: "tid",
    label: "3 times per day",
    mobileLabel: "Three times per day",
    level: 2
  },
  {
    code: "qid",
    label: "4 times per day",
    mobileLabel: "Four times per day",
    level: 2
  },
  {
    code: "weekly",
    label: "Weekly",
    mobileLabel: "Every 24 hours",
    level: 3
  },
  {
    code: "every_other_week",
    label: "Every other week",
    mobileLabel: "Every 24 hours",
    level: 4
  },
  {
    code: "monthly",
    label: "Monthly",
    mobileLabel: "Every 24 hours",
    level: 5
  },
  {
    code: "q2h",
    label: "every 2 hours",
    mobileLabel: "Every 2 hours",
    level: 6
  },
  {
    code: "q3h",
    label: "every 3 hours",
    mobileLabel: "Every 3 hours",
    level: 6
  },
  {
    code: "q4h",
    label: "every 4 hours",
    mobileLabel: "Every 4 hours",
    level: 6
  },
  {
    code: "q5h",
    label: "every 5 hours",
    mobileLabel: "Every 5 hours",
    level: 6
  },
  {
    code: "q6h",
    label: "every 6 hours",
    mobileLabel: "Every 6 hours",
    level: 6
  },
  {
    code: "q7h",
    label: "every 7 hours",
    mobileLabel: "Every 7 hours",
    level: 6
  },
  {
    code: "q8h",
    label: "every 8 hours",
    mobileLabel: "Every 8 hours",
    level: 6
  },
  {
    code: "q9h",
    label: "every 9 hours",
    mobileLabel: "Every 9 hours",
    level: 6
  },
  {
    code: "q10h",
    label: "every 10 hours",
    mobileLabel: "Every 10 hours",
    level: 7
  },
  {
    code: "q11h",
    label: "every 11 hours",
    mobileLabel: "Every 11 hours",
    level: 7
  },
  {
    code: "q12h",
    label: "every 12 hours",
    mobileLabel: "Every 12 hours",
    level: 7
  },
  {
    code: "q13h",
    label: "every 13 hours",
    mobileLabel: "Every 13 hours",
    level: 7
  },
  {
    code: "q14h",
    label: "every 14 hours",
    mobileLabel: "Every 14 hours",
    level: 7
  },
  {
    code: "q15h",
    label: "every 15 hours",
    mobileLabel: "Every 15 hours",
    level: 7
  },
  {
    code: "q16h",
    label: "every 16 hours",
    mobileLabel: "Every 16 hours",
    level: 7
  },
  {
    code: "q17h",
    label: "every 17 hours",
    mobileLabel: "Every 17 hours",
    level: 7
  },
  {
    code: "q18h",
    label: "every 18 hours",
    mobileLabel: "Every 18 hours",
    level: 7
  },
  {
    code: "q19h",
    label: "every 19 hours",
    mobileLabel: "Every 19 hours",
    level: 7
  },
  {
    code: "q20h",
    label: "every 20 hours",
    mobileLabel: "Every 20 hours",
    level: 8
  },
  {
    code: "q21h",
    label: "every 21 hours",
    mobileLabel: "Every 21 hours",
    level: 8
  },
  {
    code: "q22h",
    label: "every 22 hours",
    mobileLabel: "Every 22 hours",
    level: 8
  },
  {
    code: "q23h",
    label: "every 23 hours",
    mobileLabel: "Every 23 hours",
    level: 8
  },
  {
    code: "q24h",
    label: "every 24 hours",
    mobileLabel: "Every 24 hours",
    level: 8
  }
];

/* eslint-disable */
const fullCodesDict = [
  {
    code: 'q96h',
    label: 'every 96 hours'
  },
  {
    code: 'qday',
    label: 'every day'
  },
  {
    code: 'bid',
    label: 'Twice a day'
  },
  {
    code: 'tid',
    label: '3 times per day'
  },
  {
    code: 'qid',
    label: '4 times per day'
  },
  {
    code: '5xd',
    label: '5 times per day'
  },
  {
    code: 'q4h',
    label: 'every 4 hours'
  },
  {
    code: 'q3h',
    label: 'every 3 hours'
  },
  {
    code: 'q2h',
    label: 'every 2 hours'
  },
  {
    code: 'q1h',
    label: 'every hour'
  },
  {
    code: 'qod',
    label: 'every other day'
  },
  {
    code: 'q3d',
    label: 'every 3 days'
  },
  {
    code: 'q7d',
    label: 'every 7 days'
  },
  {
    code: 'q2w',
    label: 'every 2 weeks'
  },
  {
    code: 'q30d',
    label: 'every 30 days'
  },
  {
    code: 'q2d',
    label: 'every 2 days'
  },
  {
    code: 'qweek',
    label: 'every week'
  },
  {
    code: 'qmonth',
    label: 'every month'
  },
  {
    code: 'q24h',
    label: 'every 24 hours'
  },
  {
    code: 'q12h',
    label: 'every 12 hours'
  },
  {
    code: 'q8h',
    label: 'every 8 hours'
  },
  {
    code: 'q6h',
    label: 'every 6 hours'
  },
  {
    code: '6xd',
    label: '6 times per day'
  },
  {
    code: 'qhs',
    label: 'every day at bedtime'
  },
  {
    code: 'q72h',
    label: 'every 72 hours'
  },
  {
    code: 'q48h',
    label: 'every 48 hours'
  },
  {
    code: 'qam',
    label: 'every morning'
  },
  {
    code: 'qam and qhs',
    label: 'every day in the morning and at bedtime'
  },
  {
    code: 'once',
    label: 'once'
  },
  {
    code: 'q36h',
    label: 'every 36 hours'
  },
  {
    code: '2xw',
    label: 'twice a week'
  },
  {
    code: '3xw',
    label: 'three times per week'
  },
  {
    code: 'q18h',
    label: 'every 18 hours'
  },
  {
    code: '4xw',
    label: '4 times per week'
  },
  {
    code: '5xw',
    label: '5 times per week'
  },
  {
    code: 'qpm',
    label: 'every evening'
  },
  {
    code: 'qac',
    label: 'before meals'
  },
  {
    code: 'qpc',
    label: 'after meals'
  },
  {
    code: 'qpchs',
    label: 'after meals and at bedtime'
  },
  {
    code: '6xw',
    label: '6 times per week'
  },
  {
    code: 'per pkg dir',
    label: 'Per package directions'
  },
  {
    code: 'q10pm',
    label: 'every evening at 10 PM.'
  },
  {
    code: 'q5h',
    label: 'every 5 hours'
  },
  {
    code: 'q6pm',
    label: 'every evening at 6 PM.'
  },
  {
    code: 'q8am',
    label: 'every morning at 8'
  },
  {
    code: 'qachs',
    label: 'before meals and at bedtime'
  },
  {
    code: 'hs',
    label: 'daily at bedtime'
  },
  {
    code: 'qday7',
    label: 'daily at 7'
  },
  {
    code: 'qday8',
    label: 'daily at 8'
  },
  {
    code: 'qday9',
    label: 'daily at 9'
  },
  {
    code: 'qday10',
    label: 'daily at 10'
  },
  {
    code: 'udr',
    label: 'as directed'
  },
  {
    code: 'tidac',
    label: '3 times per day before meals'
  },
  {
    code: 'bidac',
    label: '2 times per day before meals'
  },
  {
    code: 'bidmeal',
    label: '2 times per day with meals'
  },
  {
    code: 'qinths',
    label: 'between meals and at bedtime'
  },
  {
    code: 'qint',
    label: 'between meals'
  },
  {
    code: 'qidmeal',
    label: '4 times per day with meals'
  },
  {
    code: 'q2h wa',
    label: 'every 2 hours while awake'
  },
  {
    code: 'q3h wa',
    label: 'every 3 hours while awake'
  },
  {
    code: 'qdwb',
    label: 'daily with breakfast daily '
  },
  {
    code: 'qd13',
    label: 'daily at 1300'
  },
  {
    code: 'qd11',
    label: 'daily at 11'
  },
  {
    code: 'q6h',
    label: 'every 6 hours HHN'
  },
  {
    code: 'tidpc',
    label: '3 times per day after meals'
  },
  {
    code: 'q4h',
    label: 'every 4 hours HHN'
  },
  {
    code: 'q6h',
    label: 'every 6 hours custom'
  },
  {
    code: 'q4h wa',
    label: 'every 4 hours while awake'
  },
  {
    code: 'qday13',
    label: 'every day at 1300'
  },
  {
    code: '30min ac bkft',
    label: '30 min before breakfast'
  },
  {
    code: 'qid',
    label: '4 times daily custom '
  },
  {
    code: 'q12h',
    label: 'every 12 hours custom'
  },
  {
    code: '',
    label: 'clarify frequency'
  },
  {
    code: 'bid ',
    label: '2 times per day custom'
  },
  {
    code: 'qsf',
    label: 'every shift'
  },
  {
    code: 'qday',
    label: 'every day custom'
  },
  {
    code: 'lvp2',
    label: 'lvp2'
  },
  {
    code: 'lvp3',
    label: 'lvp3'
  },
  {
    code: 'q4h',
    label: 'every 4 hours custom'
  },
  {
    code: 'qac',
    label: '15 min before meals'
  },
  {
    code: 'pc brkfst',
    label: 'after breakfast'
  },
  {
    code: 'pc lunch',
    label: 'after lunch'
  },
  {
    code: '',
    label: 'flush'
  },
  {
    code: 'tth',
    label: 'tuesday & thursday'
  },
  {
    code: 'q8h',
    label: 'every 8 hours custom'
  },
  {
    code: 'lvp1',
    label: 'lvp1'
  },
  {
    code: 'ssi',
    label: 'sliding scale'
  },
  {
    code: 'lvp4',
    label: 'lvp4'
  },
  {
    code: 'lvp5',
    label: 'lvp5'
  },
  {
    code: 'mwf',
    label: 'monday, wednesday, friday'
  },
  {
    code: 'bidrt',
    label: 'bidrt'
  },
  {
    code: 'qac',
    label: '10 minutes before meals'
  },
  {
    code: 'q_h',
    label: 'every _____ hour'
  },
  {
    code: '30 min ac lun',
    label: '30 min before lunch'
  },
  {
    code: '30 min ac din',
    label: '30 min before dinner'
  },
  {
    code: 'tuesday',
    label: 'tuesday'
  },
  {
    code: 'wednesday',
    label: 'wednesday'
  },
  {
    code: 'friday',
    label: 'friday'
  },
  {
    code: 'sat',
    label: 'saturday'
  },
  {
    code: '3x per week',
    label: 'three times per week'
  },
  {
    code: 'sun',
    label: 'sunday'
  },
  {
    code: 'mon',
    label: 'monday'
  },
  {
    code: 'tid custom',
    label: 'three times daily custom'
  },
  {
    code: 'tid custom',
    label: 'three times per day custom '
  },
  {
    code: 'tid',
    label: 'tid custom'
  },
  {
    code: 'tid custom',
    label: 'three times per day custom'
  },
  {
    code: 'tts',
    label: 'tues,thurs,sat'
  },
  {
    code: 'thur',
    label: 'thursday'
  },
  {
    code: 'qd 12',
    label: 'daily at 1200'
  },
  {
    code: 'tidac',
    label: 'tid before meals'
  },
  {
    code: 'bid',
    label: 'bid'
  },
  {
    code: 'bidac',
    label: 'bid before meals'
  },
  {
    code: 'qd custom',
    label: 'daily custom'
  },
  {
    code: '',
    label: 'run 33 mls/hr x6 hr ,17 mls/hr x18 hrs'
  },
  {
    code: 'tidmeals',
    label: 'three times daily with meals'
  },
  {
    code: 'tidw/m',
    label: 'three times daily with meals'
  },
  {
    code: 'tidmeals',
    label: 'three times daily with meals'
  }
];
/* eslint-enable */

module.exports = codes;
